
interface Ititle {
    title:string,
    labels?:any
}

const Title = ({title}:Ititle) => {
    return(
        <>
        <div className="text-base font-bold">{title}</div>
        </>
    )
}

export default Title;



